<template>
  <div class="statistics">
    <div class="row">
      <div class="key">商品数量:</div>
      <div class="val">{{ statistics.num }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    checkedList: { type: Array },
  },
  computed: {
    statistics() {
      let total = {
        num: 0
      }
      this.checkedList.forEach(item => {
        total.num += item.quantity ? item.quantity - 0 : item.num - 0
      })
      return total
    }
  },
  data() {
    return {
    };
  },
  methods: {
  }
}
</script>

<style lang='scss' scoped>
.row {
  display: flex;
  margin-bottom: 5px;
  color: #000;

  .key {
    width: 60px;
    margin-right: 10px
  }

  .val {
    color: #B4272D;
  }
}

/deep/.el-popover {
  background-color: pink !important;
}
</style>